import store from '@/store/index.js'
let dic = store.state.dic;

export default function Configs(that) {

    const formItems = [
        {
            label: "学院",
            span: 12,
            model: "collegeName",
            labelClass: 'info-label',
        },
        {
            label: "专业",
            span: 12,
            model: "majorName",
            labelClass: 'info-label',
        },
        {
            label: "班级",
            span: 12,
            model: "className",
            labelClass: 'info-label',
        },
        {
            label: "入学年份",
            span: 12,
            model: "enrollmentYear",
            labelClass: 'info-label',
        },

        {
            label: "培养层次",
            span: 8,
            model: "academicDegreeName",
            type: 'select',
        },
        {
            label: "学制",
            span: 12,
            model: "academicYearName",
            type: "select",
            disabled: true,
            labelClass: 'info-label'
        },
        {
            label: "学籍状态",
            span: 12,
            model: "studentStatusName",
            labelClass: 'info-label',
        },

        {
            label: "籍贯",
            span: 12,
            model: "nativePlace",
        },
        {
            label: "身份证号",
            span: 12,
            model: "idCard",
            labelClass: 'info-label',
        },
        {
            label: "本人电话",
            span: 12,
            model: "phoneNumber",
            labelClass: 'info-label',
        },
        {
            label: "家庭住址",
            span: 12,
            model: "addressInfo",
            labelClass: 'info-label',
        },
        {
            label: "家长电话",
            span: 12,
            model: "familyPhone",
        },
        {
            label: "民族",
            span: 12,
            model: "nationName",
            labelClass: 'info-label',
        },
        {
            label: "政治面貌",
            span: 12,
            model: "politicalName",
            labelClass: 'info-label',
        },
        {
            label: "入党、团年月",
            span: 12,
            model: "joinPartyTime",
            type: 'date',
        },
        {
            label: "曾用名",
            span: 12,
            model: "usedName",
            disabled: true
        },
        {
            label: "常用QQ",
            span: 12,
            model: "qqCode",
            placeholder: '请输入',
            labelClass: 'info-label'
        },
        {
            label: "常用微信",
            span: 12,
            model: "wxCode",
            placeholder: '请输入',
            labelClass: 'info-label'
        },
        {
            label: "邮箱",
            span: 12,
            model: "email",
            placeholder: '请输入',
            labelClass: 'info-label'
        },
        {
            label: "特长、爱好",
            span: 12,
            model: "hobby",
            maxlength: 30,
            showLimit: true,
        },
       
        // {
        //     label: "家庭出身",
        //     span: 12,
        //     model: "familyBackgroundName",
        // },
        {
            label: "健康状况",
            span: 12,
            model: "healthConditionName",
        },
        {
            label: "邮编",
            span: 12,
            model: "postcode",
        },
        // {
        //     label: "毕业年份",
        //     span: 12,
        //     model: "graduateYear",
        //     labelClass: 'info-label',
        // },
        {
            label: "考生号",
            span: 12,
            model: "examNumber",
            labelClass: 'info-label',
        },
        {
            label: "高考成绩",
            span: 12,
            model: "examScore",
            labelClass: 'info-label',
        },
    ]

    const familyTableColumns = [
        {
            label: "关系",
            prop: "relationship",
            show: true,
            align: "center",
        },
        {
            label: "亲属姓名",
            prop: "name",
            show: true,
            align: "center",
        },
        {
            label: "出生日期",
            prop: "dateBirth",
            align: "center",
            type: 'date',
            show: true
        },
        {
            label: "学历",
            prop: "degree",
            show: true,
            align: "center",
        },
        {
            label: "政治面貌",
            prop: "politicalCode",
            type: 'select',
            show: true,
            align: "center",
        },
        {
            label: "工作单位",
            prop: "unit",
            show: true,
            align: "center",
        },
        {
            label: "联系电话",
            prop: "contactPhone",
            show: true,
            align: "center",
        },
        {
            label: "职业",
            prop: "job",
            show: true,
            align: "center",
        },
        // {
        //     label: "收入（元）",
        //     prop: "income",
        //     align: "center",
        //     show: true
        // },
        {
            label: "备注",
            prop: "remark",
            align: "center",
            show: true
        },
    ]

    const jxfFormItems = [
        // {
        //     label: "姓名",
        //     span: 12,
        //     model: "name",
        //     disabled:true,
        //     labelClass:'info-label'
        // },
        // {
        //     label: "身份证号",
        //     span: 12,
        //     model: "idCard",
        //     disabled:true,
        //     labelClass:'info-label'
        // },
        {
            label: "身高",
            span: 12,
            model: "height",
            placeholder: '示例：170，即代表1米70',
            labelClass: 'info-label'
        },
        {
            label: "体重",
            span: 12,
            model: "weight",
            placeholder: '示例：50，即代表体重50kg',
            labelClass: 'info-label'
        },
        {
            label: "尺码",
            span: 12,
            model: "dressSize",
            type: 'select',
            placeholder: '请选择尺码',
            labelClass: 'info-label'
        },
        {
            label: "鞋码",
            span: 12,
            model: "shoeSize",
            placeholder: '示例：40，即代表鞋码40码',
            labelClass: 'info-label'
        },
        {
            label: "备注",
            span: 24,
            model: "remark",
            type: 'textarea',
            placeholder: '请填写备注',
            labelClass: 'info-label'
        },
    ]

    const dormotoryItems = [
        {
            label: "宿舍校区",
            span: 8,
            model: "campusName",
            type: 'select',
            labelClass: 'info-label'
        },
        {
            label: "宿舍区",
            span: 8,
            model: "areaName",
            type: 'select',
            labelClass: 'info-label'
        },
        {
            label: "楼栋号",
            span: 8,
            model: "buildingName",
            type: 'select',
            labelClass: 'info-label'
        },
        // {
        //     label: "所在楼层",
        //     span: 8,
        //     model: "44",
        //     type: 'select',
        //     labelClass:'info-label'
        // },
        {
            label: "房间号",
            span: 8,
            model: "houseName",
            type: 'select',
            labelClass: 'info-label'
        },
        {
            label: "房间类型",
            span: 8,
            model: "typeName",
            type: 'select',
            labelClass: 'info-label'
        },
        {
            label: "床位编号",
            span: 8,
            model: "bedName",
            type: 'select',
            labelClass: 'info-label'
        },
    ]
    return {
        formItems,
        familyTableColumns,
        jxfFormItems,
        dormotoryItems
    }
}
